import React, { useEffect, useCallback, useMemo, useState } from "react";
import { Form, Row, Col, Button, Spinner, Modal } from 'react-bootstrap';
import config from 'react-global-configuration';
import AWS from 'aws-sdk';
import { getCurrentUser, signOut, fetchAuthSession } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import HeaderComponent from '../../components/header';

function Landing(params) {

    const [load, setLoad] = useState(false);
    const [isGroupGeo, setIsGroupGeo] = useState(false);
    const [isGroupRiskradar, setIsGroupRiskradar] = useState(false);
    const containerStyle = useMemo(() => ({ width: "100%", height: "calc(100vh - 360px)", display: 'flex', justifyContent: 'center', alignItems: 'center' }), []);

    const navigate = useNavigate();


    const Private = async () => {
        try {
            const { username, userId, signInDetails } = await getCurrentUser();
            const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};

            const groups = accessToken.payload['cognito:groups'];
            const isGroupGeo = groups && groups.includes('Customer/Geo');
            const isGroupRiskradar = groups && groups.includes('Customer/Riskradar');
            const isAuthenticated = username || username !== ''


            setIsGroupRiskradar(isGroupRiskradar);
            setIsGroupGeo(isGroupGeo);

            if (!isAuthenticated && !isGroupRiskradar && !isGroupGeo) {
                navigate('/');
                await signOut();
                localStorage.clear();
                window.location.reload();
            }

        } catch (error) {
            navigate('/');
            await signOut();
            localStorage.clear();
            window.location.reload();
        }

    }

    useEffect(() => {
        Private();
        document.body.className = '';
    }, []);


    return (
        <>
            <HeaderComponent isLanding={true} />
            <section className='panel-default'>
                <h5>Acesse um dos modulos abaixo:</h5>
                <div style={containerStyle}>
                    {isGroupGeo && <a href="/geo" className="sectionButton"><i className="bi bi-globe2 float--l"></i><span>Geo</span></a>}
                    {isGroupRiskradar && <a href="/score" className="sectionButton"><i className="bi bi-journal-text float--l"></i><span>Score</span></a>}
                </div>
            </section>
        </>
    );
};

export default Landing;
